import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonFooter } from '@ionic/react';

import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { UpdateRoomBookedModal } from './Modal_UpdateBookedRoom';
import { EnterCheckInInfoModal } from './Modal_EnterCheckInInfo';

//import '../css/hotelCss.css';
import '../../../css/layout.css';

import { UpdateCheckInDateModal } from './Modal_Update_checkInDate';
import { UpdateCheckOutDateModal } from './Modal_Update_checkOutDate';
import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import { format, compareAsc, differenceInDays } from 'date-fns';

import {v4 as uuid} from 'uuid';



export function BookedRoomDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [merchantPhoneNumber, setMerchantPhoneNumber ] = useState(authenticatedMerchent_context.companyPhoneNumber);
    const [merchantPhoneNumber_mtnMomo, setMerchantPhoneNumber_mtnMomo ] = useState(authenticatedMerchent_context.mtnCompanyPhoneNumber);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [bookedFirstName, setBookedFirstName] = useState(null);
    let [bookedLastName, setBookedLastName] = useState(null);
    let [bookedPhoneNumber, setBookedPhoneNumber] = useState(null);
    let [bookedEmail, setBookedEmail] = useState(null);

    let [bookedStartDate, setBookedStartDate] = useState(null);
    let [bookedEndDate, setBookedEndDate] = useState(null);

    let [numOfNights, setDateRangeNumberOfNights] = useState(null);
    let [guestPayAmount, setGuestPayAmount] = useState(null);
    let [customerCheckInPhoneNumber, setCustomerCheckInPhoneNumber] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    let [showPasswordModal_refund, setShowPasswordModal_refund] = useState(false);

    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);

    let [checkInModal, setCheckInModal] = useState(false);

    //let [enteredPassword, setEnterPassword] = useState(null);

    let [viewInventoryBookedRoomDetailData, setViewInventoryBookedRoomDetailData] = useState([]);
    let [bookingStatus, setBookingStatus] = useState('bookToCheckIn');

    let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showUpdateBookedRoomModal, setShowUpdateBookedRoomModal] = useState(false);
    let [showUpdateCheckInDateModal, setShowUpdateCheckInDateModal] = useState(false);
    let [showUpdateCheckOutDateModal, setShowUpdateCheckOutDateModal] = useState(false);

    let [roomGuestInvoiceAttachment, setRoomGuestInvoiceAttachment] = useState(null);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let [disableRefundButton, setDisableRefundButton] = useState(false);

    let [displaySetButton_refund, setDisplaySetButton_refund] = useState('inline-block');
    let [displayResetButton_refund, setDisplayResetButton_refund] = useState('none');
    let [disableSetButton_refund, setDisableSetButton_refund] = useState(false);
    let [disableResetButton_refund, setDisableResetButton_refund] = useState(false);

    let [checkInInvoice_send, setCheckInInvoice_send] = useState(null);
    let [checkInInvoice_sent, setCheckInInvoice_sent] = useState(null);
    let [checkInInvoice_confirmPaid, setCheckInInvoice_confirmPaid] = useState(null);
        let [checkInInvoice_confirmPaid_non_member, setCheckInInvoice_confirmPaid_non_member] = useState(null);
    let [checkInInvoice_paid, setCheckInInvoice_paid] = useState(null);

    let [partialPaymentStatus, setPartialPaymentStatus] = useState(false);

    let [momo_provider, setMomoProvider] = useState('');
    let [momo_financial_transaction_id, setFinancialTransactionId] = useState(''); 
    let [momo_external_id, setExternalId] = useState('');
    let [momo_amount, setAmount] = useState('');
    let [momo_currency, setCurrency] = useState('');
    let [momo_party_id_type, setPartyIdType] = useState('');
    let [momo_party_id, setPartyId] = useState('');
    let [momo_payer_message, setPayerMessage] = useState('');
    let [momo_payee_note, setPayeeNote] = useState('');
    let [momo_pay_status, setPayStatus] = useState('');

    let [momo_pay_status_db, setPayStatus_db] = useState('');

    let [internalReferenceID, setInternalReferenceID] = useState('');

    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);

    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(null);

    let enterPayRef = useRef(0);
    let paymentTypeRef = useRef('MTN-MOMO');

    let enterDepositRef = useRef(0);
    let enterRefundRef = useRef(0);

    let enterDiscountRef = useRef(0);
    let enterIncreaseRef = useRef(0);


    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(() => {

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });

          return noImageFile;
        
    });


    function handleEnterAttachement() {  

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });
        
        setCheckInAttachment_ID(noImageFile);

    }

    useEffect(() => {


            /*
            let formData = new FormData();
            formData.append('Tracker', 74113);
            formData.append('user', acctID);
            formData.append('xCheckInRoomID', props.data.roomID);
            formData.append('xBookingID', props.data.bookingID);
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: 74113,
                    user: acctID,
                    xCheckInRoomID: props.data.roomID,
                    xBookingID: props.data.bookingID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    let date1 = new Date(cols[20]);
                    let date2 = new Date(cols[21]);
                    let timeDiff;

 
                    timeDiff = Math.abs(differenceInDays(
                        new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                        new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                      ));


                    setBookedStartDate(date1);
                    setBookedEndDate(date2);

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));

                    }

                    if(cols[25] == 'N/A')
                    {
                        
                        if(cols[28] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) == 0.00)
                        {
                            setBookingStatus('bookToCheckIn_depositPaid');
                            
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[28] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) > 0.00)
                        {
                            setBookingStatus('bookToCheckIn_depositPaid');

                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setPartialPaymentStatus(true);
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }
                    
                    setPayStatus_db(cols[36]);

                    setViewInventoryBookedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: cols[8],
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: cols[19],
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            transactionID: cols[26],
                            transactionTotalAmount: parseFloat(cols[27]*1).toFixed(2),
                            transactionStatus: cols[28],
                            momo_provider: cols[29],
                            momo_financial_transaction_id: cols[30],
                            momo_external_id: cols[31],
                            momo_amount: cols[32],
                            momo_party_id: cols[33],
                            momo_payer_message: cols[34],
                            momo_payee_note: cols[35],
                            momo_pay_status: cols[36],
                            payment_type: cols[37],
                            roomGuestInvoiceAttachment: cols[38],
                            internalReferenceID: cols[39],
                        })
                    });
                    
                    setCustomerCheckInPhoneNumber(cols[16]);
                    setRoomSalePrice(parseFloat(cols[19]).toFixed(2));
                    setInternalReferenceID(cols[39]);
                }    
            })
    }, []);


    function onSubmitNewDateHandler(e)
    {
        //setViewInventoryBookedRoomDetailData([]);


        /*
        let formData = new FormData();
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', props.data.roomID);
        formData.append('xBookingID', props.data.bookingID);
        */

        let Tracker = '';
        let startDateRange = '';
        let endDateRange = '';
        let checkInNumberOfNights = '';
        let currentDate = '';

        if(bookingStatus == "bookToCheckIn")
        {
            if(e[0] == 'IN')
            {
                let date1 = new Date(new Date(e[1]));
                let date2 = new Date(new Date(bookedEndDate));
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_IN_unpaid');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_IN_unpaid';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
            else if(e[0] == 'OUT')
            {
                let date1 = new Date(new Date(bookedStartDate));
                let date2 = new Date(new Date(e[1]));
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));


                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_OUT_unpaid');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff); 
                */

                Tracker = '74113_U_OUT_unpaid';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
                currentDate = new Date(Date.now() + 86400000).toISOString().substring(0, 10);

            }
        }
        else if(bookingStatus == "bookToCheckIn_depositPaid")
        {
            if(e[0] == 'IN')
            {
                let date1 = new Date(new Date(e[1]));
                let date2 = new Date(new Date(bookedEndDate));
                let timeDiff;

 
                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_IN');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_IN';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;

            }
            else if(e[0] == 'OUT')
            {
                let date1 = new Date(new Date(bookedStartDate));
                let date2 = new Date(new Date(e[1]));
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                  ));
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_OUT'); 
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_OUT';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
                currentDate = new Date(Date.now() + 86400000).toISOString().substring(0, 10);

            }
        }


        /*
        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xCheckInRoomID: props.data.roomID,
                xBookingID: props.data.bookingID,
                xStartDateRange: startDateRange,
                xEndDateRange: endDateRange,
                xCurrentDateRange: currentDate,
                xCheckInNumberOfNights: checkInNumberOfNights,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert(data);

            /*let rows = data.toString().split('~~~');
        
            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                let date1 = new Date(cols[20]);
                let date2 = new Date(cols[21]);
                let timeDiff;


                timeDiff = Math.abs(differenceInDays(
                    new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
                    new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
                    ));

                if(date1.getDate() == date2.getDate())
                {
                    setDateRangeNumberOfNights(1);
                    setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                }
                else
                {
                    setDateRangeNumberOfNights(calcNumberOfNights);
                    setGuestPayAmount(parseFloat(cols[19]*calcNumberOfNights).toFixed(2));

                }


                setViewInventoryBookedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                    return prevViewInventoryOccupiedRoomDetailData.concat({
                        roomID: cols[0],
                        roomType: cols[1],
                        roomDescription: cols[2],
                        roomPartNum: cols[3],
                        roomPhoneNumber: cols[4],
                        address: cols[5],
                        city: cols[6],
                        country: cols[7],
                        roomSalePrice: cols[8],
                        roomPic1: cols[9],
                        roomPic2: cols[10],
                        roomPic3: cols[11],
                        roomPic4: cols[12],
                        attachment: cols[13],
                        roomGuestFirstName: cols[14],
                        roomGuestLastName: cols[15],
                        roomGuestPhoneNumber: cols[16],
                        roomGuestEmail: cols[17],
                        roomGuestPaymentType: cols[18],
                        roomGuestPrice: cols[19],
                        roomGuestCheckInDateBooked: cols[20],
                        roomGuestCheckOutDateBooked: cols[21],
                        roomGuestCheckInDateActual: cols[22],
                        merchantInvoiceID: cols[23],
                        customerInvoiceID: cols[24],
                        invoiceSentStatus: cols[25],
                        transactionID: cols[26],
                        transactionTotalAmount: cols[27],
                        transactionStatus: cols[28],
                        roomGuestInvoiceAttachment: cols[29],
                    })
                });
            }*/
            
            //alert('Booking Date Has been updated to '+e[1]);
            alert(data);

            setShowUpdateCheckOutDateModal(false);
            props.closeModal();

        })
        .catch(error => {
            console.error(error);
        })

    }

    function createInvoice(event)
    {
        /*
        let formData0 = new FormData();
        formData0.append('Tracker', '74706_deposit');
        formData0.append('user', acctID);
        formData0.append('xCheckInRoomID', event[6]);
        formData0.append('xCheckInFirstName', event[7]);
        formData0.append('xCheckInLastName', event[8]);
        formData0.append('xCheckInMobileNumber', event[9]);
        formData0.append('xCheckInEmail', event[10]);
        //formData0.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
        //formData0.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
        formData0.append('xImageFile', checkInAttachment_ID);
        formData0.append('xCheckInNonMemberPaymentType', event[11]);
        formData0.append('xCheckInNonMemberPaymentAmount', parseFloat(event[12]).toFixed(2));
        formData0.append('xCheckInDateBooked', bookedStartDate.toISOString().substr(0, 10));
        formData0.append('xCheckOutDateBooked', bookedEndDate.toISOString().substr(0, 10));
        formData0.append('xCheckInNumberOfNights', numOfNights);
        formData0.append('xBookingID', props.data.bookingID);
       

        const requestOptions0 = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData0
        }
        */


        const requestOptions0 = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74706_deposit',
                user: acctID,
                xCheckInRoomID: event[6],
                xCheckInFirstName: event[7],
                xCheckInLastName: event[8],
                xCheckInMobileNumber: event[9],
                xCheckInEmail: event[10],
                //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                xImageFile: checkInAttachment_ID,
                xCheckInNonMemberPaymentType: event[11],
                xCheckInNonMemberPaymentAmount: parseFloat(event[12]).toFixed(2),
                xCheckInDateBooked: bookedStartDate.toISOString().substr(0, 10),
                xCheckOutDateBooked: bookedEndDate.toISOString().substr(0, 10),
                xCheckInNumberOfNights: numOfNights,
                xBookingID: props.data.bookingID,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
        .then(res => res.text())
        .then(data0 => {

                        let cols = data0.toString().split('|');

                        alert('Invoice '+cols[0]+' Created');


        })
        .catch(error => {
            console.error(error);
        })

    }


            //submitPay(parseFloat(event[12]).toFixed(2), event[3], event[7] + " " + event[8] + " Momo Payment", "Bluefin Hotel Invoice");
    //function submitPay(_customerPayAmount, _payPartyId, _payPayerMessage, _payPayeeNote)

    function submitPay(event)
    {
                                    // alert('zero');
                                    // alert(event);
                                    // alert(event[14]);
                                    // alert(event)
        setDisablePayButton(true);

        if(event[14] == "initial")
        {         
            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_deposit',
                    user: acctID,
                    xCheckInRoomID: event[6],
                    xCheckInFirstName: event[7],
                    xCheckInLastName: event[8],
                    xCheckInMobileNumber: event[9],
                    xCheckInEmail: event[10],
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                    xImageFile: checkInAttachment_ID,
                    xCheckInNonMemberPaymentType: event[11],
                    xCheckInNonMemberPaymentAmount: parseFloat(event[12]).toFixed(2),
                    xCheckInDateBooked: bookedStartDate.toISOString().substr(0, 10),
                    xCheckOutDateBooked: bookedEndDate.toISOString().substr(0, 10),
                    xCheckInNumberOfNights: numOfNights,
                    xBookingID: props.data.bookingID,
                    sessionID: sessionID,
                    
    
                }),
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                            let cols = data0.toString().split('|');
                            let merchantInvoiceID = cols[0];
                            let customerInvoiceID = cols[1];
                            let internalReferenceID_initial = acctID+"-"+merchantInvoiceID+"-"+customerCheckInPhoneNumber;
                            setInternalReferenceID(internalReferenceID_initial);

                            //alert('one');
                            //alert(internalReferenceID_initial)

                                let xReferenceID = uuid();
                                //setInternalReferenceID(xReferenceID);

                                if (paymentTypeRef.current.value == 'cash'|| paymentTypeRef.current.value == 'CASH')
                                {
                                    ///prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);
                                    prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined, xReferenceID.toString(),,,,,,,,merchantInvoiceID,customerInvoiceID,internalReferenceID_initial]);

                                    alert("Payment Type is Cash Confirmed");

                                    return;
                                }
                                return new Promise((resolve, reject) => {


                                    const customerPayAmount = parseFloat(event[13]).toFixed(2);
                                    const payCurrency = 'GHS';
                                    //const payExternalId = '';
                                    const payPartyId = event[3].replace(/^0+/, '');
                                    const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
                                    const payPayeeNote = "Bluefin Hotel Invoice";

                                    const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
                                    const apikey = "e288a3938db14c8c9dfe3543427a141e";
                                    const concatenatedString = `${apiuser}:${apikey}`;
                                    const base64EncodedString = window.btoa(concatenatedString);


                                    fetch(baseURL+'mtnapi/collection/token/', {
                                        method: 'POST',                                                  
                                        //mode: 'no-cors',
                                        //body: '',
                                        //Request headers
                                        headers: {
                                            'authorization': 'Basic '+ base64EncodedString,
                                            //'cache-Control': 'no-cache',
                                            //'content-_type': 'application/json',
                                            'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                                            'x-target-environment': 'mtnghana',
                                            'x-reference-id': xReferenceID.toString(),
                                            'x-internal-reference-id': internalReferenceID_initial,
                                            'tracker': '74108_B_update_successful',
                                            'user': acctID,
                                            'customer_account_id': 'non_member',
                                            'schema': schema,
                                            'x_project_id': 'N/A',
                                            'x_customer_mobilenumber': event[3],
                                            'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                                            'x_invoice_id': event[1],
                                            'x_customer_invoice_id': event[2],
                                            'x_immediate_destination': acctID,
                                            'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                                            'session_id': sessionID,
                                            'momo_url': 'collection/v1_0/requesttopay',
                                            'confirm_payment': 'confirm_or_reject',
                                            // 'request_to_pay': JSON.stringify({
                                            //     "amount": customerPayAmount,
                                            //     "currency": payCurrency,
                                            //     "externalId": xReferenceID.toString(),
                                            //     "payer": {
                                            //         "partyIdType": "MSISDN",
                                            //         "partyId": "233"+payPartyId
                                            //     },
                                            //     "payerMessage": payPayerMessage,
                                            //     "payeeNote": payPayeeNote
                                            // }),
                                            'customer_pay_amount': customerPayAmount,
                                            'pay_currency': payCurrency,
                                            'external_id': xReferenceID.toString(),
                                            'party_id_type': 'MSISDN',
                                            'party_id': payPartyId,
                                            'pay_payer_message': payPayerMessage,
                                            'pay_payee_note': payPayeeNote,

                                        },

                                    })
                                    .then(res => res.json())
                                    .then(res => {

                                        prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, xReferenceID.toString(), res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, merchantInvoiceID, customerInvoiceID, internalReferenceID_initial]);

                                    })
                                })
                            })
                        }
                        else

                        {
                                setDisablePayButton(true);
                                let xReferenceID = uuid();
                                //setInternalReferenceID(xReferenceID);

                                if (paymentTypeRef.current.value == 'cash'|| paymentTypeRef.current.value == 'CASH')
                                {
                                    ///prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);
                                    //prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined, xReferenceID.toString()]);
                                    prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, undefined, undefined, xReferenceID.toString(),,,,,,,,event[1],event[2],internalReferenceID]);

                                    alert("Payment Type is Cash Confirmed");

                                    return;
                                }
                                return new Promise((resolve, reject) => {


                                    const customerPayAmount = parseFloat(event[13]).toFixed(2);
                                    const payCurrency = 'GHS';
                                    //const payExternalId = '';
                                    const payPartyId = event[3].replace(/^0+/, '');
                                    const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
                                    const payPayeeNote = "Bluefin Hotel Invoice";

                                    const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
                                    const apikey = "e288a3938db14c8c9dfe3543427a141e";
                                    const concatenatedString = `${apiuser}:${apikey}`;
                                    const base64EncodedString = window.btoa(concatenatedString);


                                    fetch(baseURL+'mtnapi/collection/token/', {
                                        method: 'POST',                                                  
                                        //mode: 'no-cors',
                                        //body: '',
                                        //Request headers
                                        headers: {
                                            'authorization': 'Basic '+ base64EncodedString,
                                            //'cache-Control': 'no-cache',
                                            //'content-_type': 'application/json',
                                            'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                                            'x-target-environment': 'mtnghana',
                                            'x-reference-id': xReferenceID.toString(),
                                            'x-internal-reference-id': internalReferenceID,
                                            'tracker': '74108_B_update_successful',
                                            'user': acctID,
                                            'customer_account_id': 'non_member',
                                            'schema': schema,
                                            'x_project_id': 'N/A',
                                            'x_customer_mobilenumber': event[3],
                                            'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                                            'x_invoice_id': event[1],
                                            'x_customer_invoice_id': event[2],
                                            'x_immediate_destination': acctID,
                                            'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                                            'session_id': sessionID,
                                            'momo_url': 'collection/v1_0/requesttopay',
                                            'confirm_payment': 'confirm_or_reject',
                                            // 'request_to_pay': JSON.stringify({
                                            //     "amount": customerPayAmount,
                                            //     "currency": payCurrency,
                                            //     "externalId": xReferenceID.toString(),
                                            //     "payer": {
                                            //         "partyIdType": "MSISDN",
                                            //         "partyId": "233"+payPartyId
                                            //     },
                                            //     "payerMessage": payPayerMessage,
                                            //     "payeeNote": payPayeeNote
                                            // }),
                                            'customer_pay_amount': customerPayAmount,
                                            'pay_currency': payCurrency,
                                            'external_id': xReferenceID.toString(),
                                            'party_id_type': 'MSISDN',
                                            'party_id': payPartyId,
                                            'pay_payer_message': payPayerMessage,
                                            'pay_payee_note': payPayeeNote,

                                        },

                                    })
                                    .then(res => res.json())
                                    .then(res => {

                                        prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, xReferenceID.toString(), res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, event[1], event[2], internalReferenceID]);

                                    })
                                })
                            

                        }
                        
                                
    }


    function submitPay_refund(event)
    {

        setDisablePayButton(true);

        if (paymentTypeRef.current.value == 'CASH')
        {
            refund([event, paymentTypeRef.current.value]);

            return;
        }
        return new Promise((resolve, reject) => {


            const customerPayAmount = parseFloat(event[5]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[3].replace(/^0+/, '');
            const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
            const apikey = "218c665182e447538d0e6ac6f36ad3b4";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            let referenceIdToRefund = "";
            if (event[10] == 'refund' || event[10] == 'transfer') {


                referenceIdToRefund = event[9];
            }

            let xReferenceID = uuid();

            let body_refund = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": referenceIdToRefund,
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote,
                "referenceIdToRefund": referenceIdToRefund,
            }
            let body_transfer = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId": referenceIdToRefund,
                "payer": {
                    "partyIdType": "MSISDN",
                    "partyId": "233"+payPartyId
                },
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote
            }

            let body_deposit = {
                "amount": customerPayAmount,
                "currency": payCurrency,
                "externalId":referenceIdToRefund,
                "payer": {
                    "partyIdType": "MSISDN",
                    "partyId": "233"+payPartyId
                },
                "payerMessage": payPayerMessage,
                "payeeNote": payPayeeNote
            }

            let fetch_body;

            if(event[10] == 'refund')
            {
                alert("In Refund"); 
                fetch_body = body_refund;
            }
            else if(event[10] == 'transfer')
            {
                alert("In transfer"); 
                fetch_body = body_transfer;
            }
            else if(event[10] == 'deposit')
            {
                alert("In deposit"); 
                fetch_body = body_deposit;
            }

            fetch(baseURL+'mtnapi/disbursement/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                //credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': referenceIdToRefund,
                    'user': acctID,
                    'customer_account_id': 'non_member',
                    'x_project_id': 'N/A',
                    'x_customer_mobilenumber': event[3],
                    'x_merchant_mobilenumber': merchantPhoneNumber_mtnMomo.replace(/^0+/, ''),
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': acctID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'disbursement/v1_0/'+event[10],
                    'confirm_payment': 'confirm_or_reject_refund',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': referenceIdToRefund,
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },
                body: JSON.stringify(fetch_body),


            })
            .then(res => res.json())
            .then(res => {

                alert('AFTER submitPay_refund');
                alert(res);

                refund([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payee.partyIdType, res.payee.partyId, res.payerMessage, res.payeeNote, res.status]);

            })
        })
    }


    function prepareInvoice_thenConfirmPay_nonMember(event)
    {
                

        // if(event[0][14] == "partial_paid")
        // {

        //     const requestOptions = {
        //         method: 'POST',
        //         //credentials: 'include',
        //         headers: {
        //             'Accept': 'text/html, application/json',
        //             'content-type': 'application/json',
        //             //'cookie': 'cookie',
        //         },
        //         body: JSON.stringify({
        //             Tracker: '74108_B',
        //             user: acctID,
        //             xCustMobileNumber: event[0][3],
        //             xInvoiceID: event[0][1],
        //             xCustomerInvoiceID: event[0][2],
        //             xImmediateDestination: acctID,
        //             xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
        //             sessionID: sessionID,
        //             xPaymentType: event[1],
        //             xMomo_provider: event[2],
        //             xMomo_financial_transaction_id: event[3],
        //             xMomo_external_id: event[4],
        //             xMomo_amount: event[5],
        //             xMomo_currency: event[6],
        //             xmomo_party_id_type: event[7],
        //             xMomo_party_id: event[8],
        //             xMomo_payer_message: event[9],
        //             xMomo_payee_note: event[10],
        //             xMomo_pay_status: event[11],
        //             xInternalReferenceID: internalReferenceID,

        //         }),
        //     }

        //     fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        //     .then(res => res.text())
        //     .then(data => {

        //         confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

        //     })
        //     .catch(error => {
        //         console.error(error);
        //     })

        // }
        // else if(event[0][14] == "initial")
        // {         
        //     const requestOptions0 = {
        //         method: 'POST',
        //         //credentials: 'include',
        //         headers: {
        //             'Accept': 'text/html, application/json',
        //             'content-type': 'application/json',
        //             //'cookie': 'cookie',
        //         },
        //         body: JSON.stringify({
        //             Tracker: '74706_deposit',
        //             user: acctID,
        //             xCheckInRoomID: event[0][6],
        //             xCheckInFirstName: event[0][7],
        //             xCheckInLastName: event[0][8],
        //             xCheckInMobileNumber: event[0][9],
        //             xCheckInEmail: event[0][10],
        //             //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
        //             //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
        //             xImageFile: checkInAttachment_ID,
        //             xCheckInNonMemberPaymentType: event[0][11],
        //             xCheckInNonMemberPaymentAmount: parseFloat(event[0][12]).toFixed(2),
        //             xCheckInDateBooked: bookedStartDate.toISOString().substr(0, 10),
        //             xCheckOutDateBooked: bookedEndDate.toISOString().substr(0, 10),
        //             xCheckInNumberOfNights: numOfNights,
        //             xBookingID: props.data.bookingID,
        //             sessionID: sessionID,
                    
    
        //         }),
        //     }
    
        //     fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
        //     .then(res => res.text())
        //     .then(data0 => {
    
    //                        let cols = data0.toString().split('|');

    // alert('two');
    // alert(event);
    // alert(event[12]);
    // alert(event[13]);
    // alert(event[14]);

                            const requestOptions = {
                                method: 'POST',
                                //credentials: 'include',
                                headers: {
                                    'Accept': 'text/html, application/json',
                                    'content-type': 'application/json',
                                    //'cookie': 'cookie',
                                },
                                body: JSON.stringify({
                                    Tracker: '74108_B',
                                    user: acctID,
                                    xCustMobileNumber: event[0][3],
                                    xInvoiceID: event[12],
                                    xCustomerInvoiceID: event[13],
                                    xImmediateDestination: acctID,
                                    xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                                    sessionID: sessionID,
                                    xPaymentType: event[1],
                                    xMomo_provider: event[2],
                                    xMomo_financial_transaction_id: event[3],
                                    xMomo_external_id: event[4],
                                    xMomo_amount: event[5],
                                    xMomo_currency: event[6],
                                    xmomo_party_id_type: event[7],
                                    xMomo_party_id: event[8],
                                    xMomo_payer_message: event[9],
                                    xMomo_payee_note: event[10],
                                    xMomo_pay_status: event[11],           
                                    xInternalReferenceID: event[14],

                                }),
                            }
    
                            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                            .then(res => res.text())
                            .then(data => {

                                confirmPayment_non_member([data, event[0][1], event[13], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11], event[14]]);
    
                            })
                            .catch(error => {
                                console.error(error);
                            })
    
                
        

    }

    function merchant_nonMember_update_transaction_status(event)
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_update',
                user: acctID,
                fmc_schema: schema,
                baseUrl: baseURL,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xMomo_provider: event[1],
                xMomo_financial_transaction_id: event[2],
                xMomo_external_id: event[3],
                xMomo_amount: event[4],
                xMomo_currency: event[5],
                xmomo_party_id_type: event[6],
                xMomo_party_id: event[7],
                xMomo_payer_message: event[8],
                xMomo_payee_note: event[9],
                xMomo_pay_status: event[10],
                xInternalReferenceID: internalReferenceID,

            }),
        }


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {


        })
        .catch(error => {
            console.error(error);
        })
    }

    function confirmPayment_non_member(event)
    {

        let tracker = event[4];
        let customerInvoiceID = event[2];
        let transactionID = event[0];
        let customerPhoneNumber = event[3];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);
        formData.append('xBookingID', props.data.bookingID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        // alert('three');
        // alert(event);
        // alert(event[17]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xCheckInRoomID: event[5],
                xBookingID: props.data.bookingID,
                sessionID: sessionID,
                xPaymentType: event[6],
                xMomo_provider: event[7],
                xMomo_financial_transaction_id: event[8],
                xMomo_external_id: event[9],
                xMomo_amount: event[10],
                xMomo_currency: event[11],
                xmomo_party_id_type: event[12],
                xMomo_party_id: event[13],
                xMomo_payer_message: event[14],
                xMomo_payee_note: event[15],
                xMomo_pay_status: event[16], 
                xInternalReferenceID: event[17],


            }),
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //setDisablePayButton(false);


            if (data == 'confirmed')
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Payment Confirmed');
            }
            else if(data == 'confirmed_partial')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Payment Confirmed');

            }
            else if (data == 'confirmed_refund')
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Full refund Confirmed');
            }
            else if(data == 'confirmed_partial_refund')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Refund Confirmed');

            }
            else
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('none');

                alert('Payment Sent To Customer');
            }

            props.closeModal();
        })
    }

    function checkInModalHandler(event)
    {

        //alert(event);

        setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
        setBookedFirstName(event[3]);
        setBookedLastName(event[4]);
        setBookedPhoneNumber(event[5]);
        setBookedEmail(event[6]);

        setBookedStartDate(event[7]);
        setBookedEndDate(event[8]);

        setCheckInModal(event[0]);
    }
    function handleUpdate_checkInDate(event)
    {

        setBookedStartDate(event[1]);
        setBookedEndDate(event[2]);
        setShowUpdateCheckInDateModal(event[0]);
    }
    function handleUpdate_checkOutDate(event)
    {

        setBookedStartDate(event[1]);
        setBookedEndDate(event[2]);
        setShowUpdateCheckOutDateModal(event[0]);
    }

    function refund(event)
    {

        alert('In refund');
        alert(event);
        setDisableRefundButton(true);

        /*let formData = new FormData();
        formData.append('Tracker', '74108_B_refund');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }*/
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_refund',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xPaymentType: event[1],
                xMomo_provider: event[2],
                xMomo_financial_transaction_id: event[3],
                xMomo_external_id: event[4],
                xMomo_amount: event[5],
                xMomo_currency: event[6],
                xmomo_party_id_type: event[7],
                xMomo_party_id: event[8],
                xMomo_payer_message: event[9],
                xMomo_payee_note: event[10],
                xMomo_pay_status: event[11], 

            }),
        }


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function deleteBooking(enteredPassword)
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74193);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', props.data.roomID);
        formData.append('xBookingID', props.data.bookingID);
        formData.append('xEnterAdminPassword', enteredPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

                
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74193',
                user: acctID,
                xInventoryRoomID: props.data.roomID,
                xBookingID: props.data.bookingID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

        })

        props.closeModal(false);

    }

    function applyDiscount(event, newRoomSalePrice)
    {
        // alert("in apply Discount");
        // alert(event);
        // alert(newRoomSalePrice);

        /*let formData = new FormData();
        formData.append('Tracker', '7999_delete');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_applyDiscount_booking',
                user: acctID,
                xCheckInRoomID: event[0],
                xInvoiceID: event[1],
                xCustomerInvoiceID: event[2],
                xCheckInNumberOfNights: numOfNights,
                xCheckInNonMemberPaymentAmount: parseFloat(newRoomSalePrice).toFixed(2),
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            setViewInventoryBookedRoomDetailData([]);
            props.closeModal(false);
            
        })
        .catch(error => {
            console.error(error);
        })
    }

    function handleUpdate_room(event)
    {

        setBookedStartDate(event[1]);
        setBookedEmail(event[2]);
        setShowUpdateBookedRoomModal(event[0]);
    }

    function viewInvoiceModalHandler(event) {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setRoomGuestInvoiceAttachment(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function setDepositHandler()
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton(false);
        setDisplayResetButton('inline-block');

    }

    function resetDepositHandler()
    {
        setDisableResetButton(true);
        setDisplayResetButton('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterDepositRef.current.value = '';
        setDisableSetButton(false);
        setDisplayResetButton('none');
        setDisplaySetButton('inline-block');
    }

    function setRefundHandler()
    {
        setDisableSetButton_refund(true);
        setDisplaySetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton_refund(false);
        setDisplayResetButton_refund('inline-block');

    }

    function resetRefundHandler()
    {
        setDisableResetButton_refund(true);
        setDisplayResetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterRefundRef.current.value = '';
        setDisableSetButton_refund(false);
        setDisplayResetButton_refund('none');
        setDisplaySetButton_refund('inline-block');
    }


    function setDiscountHandler(event)
    {

        //alert(event);

        if(enterIncreaseRef.current.value > 0)
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
           // setBookingPrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
            setDisableResetButton(false);
    
            if(checkInRoomID_multiple != null)
            {
                let newRoomSalesPrice_Multiple = [];
    
                for(let i = 0; i < roomSalePrice_multiple.length; ++i)
                {
                    newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] + (roomSalePrice_multiple[i]*(enterIncreaseRef.current.value/100)));
                }
                
                setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
            }

            applyDiscount(event, roomSalePrice + (roomSalePrice*(enterDiscountRef.current.value/100)));

        }
        else
        {
            setDisableSetButton(true);
            setDisplaySetButton('none');
            setDisplayResetButton('inline-block');
            setRoomSalePrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
            //setBookingPrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
            setDisableResetButton(false);
    
            if(checkInRoomID_multiple != null)
            {
                let newRoomSalesPrice_Multiple = [];
    
                for(let i = 0; i < roomSalePrice_multiple.length; ++i)
                {
                    newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] - (roomSalePrice_multiple[i]*(enterDiscountRef.current.value/100)));
                }
                
                setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
            }

            applyDiscount(event, roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));

        }
    }
    
    function resetDiscountHandler(event)
    {
        setDisableResetButton(true);
        setDisplaySetButton('inline-block');
        setDisplayResetButton('none');
        setRoomSalePrice(event);
        enterDiscountRef.current.value = 0;
        enterIncreaseRef.current.value = 0;
        setDisableSetButton(false);
    }


    function deletBookingHandler(event)
    {
        setShowPasswordModal(true);

    }
    function onSubmitPasswordHandler_refund(event)
    {
        refund();
    }
    function onSubmitPasswordHandler(event)
    {

        deleteBooking(event);
    }
    function closeModalHandler() {

        props.closeModal();
    }

    function closeModalHandler_checkIn() {

        setRoomSalePrice(null);
        setCheckInModal(false);
        props.closeModal();
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
            <IonGrid >
                <IonRow>
                    <IonCol size='12'>
                        <h3>ROOMS BOOKED</h3>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'> Room ID</IonCol>
                    <IonCol size='6'> Price Per Night</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'> {props.data.roomID} </IonCol>
                    <IonCol size='6'> {parseFloat(props.data.roomSalePrice).toFixed(2)} </IonCol>
                </IonRow>
            </IonGrid>
        </IonHeader>

        <IonContent className='grid_content'>
            {viewInventoryBookedRoomDetailData.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow >
                    <IonCol size='3' >Category</IonCol>
                    <IonCol size='6' >Value</IonCol>
                    <IonCol size='3' >Action</IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' > Invoice ID </IonCol>
                    <IonCol size='6' >{detailData.merchantInvoiceID}</IonCol>
                    {detailData.merchantInvoiceID == 'booking_non_member' && <IonCol size='3' >
                         <IonButton > - </IonButton> 
                         {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton id='gridResultColumnButton' disabled={disablePayButton} style={{display: checkInInvoice_confirmPaid_non_member}} onClick={() => createInvoice([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_bookDeposit', '0.00', detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.roomGuestPhoneNumber, detailData.roomGuestEmail, detailData.roomGuestPaymentType, detailData.roomGuestPrice])}> Create </IonButton>}
                    </IonCol>}
                    {detailData.merchantInvoiceID != 'booking_non_member' && <IonCol size='3' > <IonButton  onClick={() => viewInvoiceModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestInvoiceAttachment])}> View </IonButton> </IonCol>}
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Change Room</IonCol>
                    <IonCol size='6' >{ 'ID: '+detailData.roomID+
                                                        'Part Number: '+detailData.roomPartNum}</IonCol>
                    <IonCol size='3' >
                        {detailData.merchantInvoiceID == 'booking_non_member' && <IonButton > - </IonButton>}
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton onClick={() => handleUpdate_room([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} > Update </IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Room Images</IonCol>
                    <IonCol size='6' >{detailData.roomType}</IonCol>
                    <IonCol size='3' >
                        <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: detailData.roomPic1, 
                        roomPic2: detailData.roomPic2, 
                        roomPic3: detailData.roomPic3, 
                        roomPic4: detailData.roomPic4, 
                        roomID: detailData.roomID, 
                        roomSalePrice: detailData.roomSalePrice
                        }}></ShowRoomPicsModal>
                        <IonButton  onClick={() => setRoomPicsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-In Date</IonCol>
                    <IonCol size='6' >{detailData.roomGuestCheckInDateBooked}</IonCol>
                    <IonCol size='3' >
                        <IonButton onClick={() => handleUpdate_checkInDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} > Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Check-Out Date</IonCol>
                    <IonCol size='6' >{detailData.roomGuestCheckOutDateBooked}</IonCol>
                    <IonCol size='3' >
                        <IonButton onClick={() => handleUpdate_checkOutDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} > Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ># of Nights</IonCol>
                    <IonCol size='6' >{numOfNights}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Contact</IonCol>
                    <IonCol size='6' >{ 'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName+
                                                        'Phone Number: '+detailData.roomGuestPhoneNumber+
                                                        'Email: '+detailData.roomGuestEmail}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Room Price</IonCol>
                    <IonCol size='6' >{detailData.roomGuestPrice}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Payment Type</IonCol>
                    <IonCol size='6' >{detailData.roomGuestPaymentType}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Deposit Paid</IonCol>
                    <IonCol size='6' >{detailData.transactionTotalAmount}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Pay</IonCol>
                    <IonCol size='6' >{(parseFloat(guestPayAmount) + parseFloat(detailData.transactionTotalAmount)).toFixed(2)}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > {enterDepositRef.current.value+' GH'} </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <h4>Discount: </h4>
                    </IonCol>
                    <IonCol size='4'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterDiscountRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{(( ( (detailData.roomSalePrice * numOfNights) - guestPayAmount )/ (detailData.roomSalePrice * numOfNights)) * 100).toFixed(2)+' %'}</h4>
                    </IonCol>
                    <IonCol size='4'> 
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDiscountHandler([detailData.roomID, detailData.merchantInvoiceID, detailData.customerInvoiceID])}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDiscountHandler(detailData.roomSalePrice)}>Reset</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='3'>
                        Deposit
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterDepositRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{enterDepositRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDepositHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDepositHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                    <IonCol  size='3'>
                        {((authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (detailData.momo_pay_status == '' || detailData.momo_pay_status == 'NO_RESPONSE' || detailData.momo_pay_status == 'FAILED' || detailData.momo_pay_status == 'N/A') && detailData.momo_pay_status != 'CASH')  && <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_bookDeposit', enterDepositRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.roomGuestPhoneNumber, detailData.roomGuestEmail, detailData.roomGuestPaymentType, detailData.roomGuestPrice, enterDepositRef.current.value, 'initial'])}> PAY </IonButton>}
                        {((authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk') && (detailData.momo_pay_status == 'PENDING' || detailData.momo_pay_status == 'CREATED')) &&  <IonButton id='gridResultColumnButton' disabled={true}  > PENDING </IonButton>}
                        {((authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'front_desk')  && (detailData.momo_pay_status == 'SUCCESSFUL' || detailData.momo_pay_status == 'CASH')) && <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_bookDeposit', enterDepositRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.roomGuestPhoneNumber, detailData.roomGuestEmail, detailData.roomGuestPaymentType, detailData.roomGuestPrice, enterDepositRef.current.value, 'partial_paid'])}> PAID - PAY </IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol>
                        <IonButton onClick={() => checkInModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestFirstName, detailData.roomGuestLastName, detailData.roomGuestPhoneNumber, detailData.roomGuestEmail, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} > Check-In Guest </IonButton>
                    </IonCol>
                    {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') &&
                    <IonCol>
                        {(detailData.merchantInvoiceID == 'booking_non_member' || detailData.transactionTotalAmount == 0.00) && <IonButton onClick={() => setShowPasswordModal(true)}> Delete Booking </IonButton>}
                    </IonCol>
                    }
                    {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') &&
                    <IonCol>
                        {(detailData.merchantInvoiceID != 'booking_non_member' || detailData.transactionTotalAmount > 0.00) && <IonButton onClick={() => setShowPasswordModal(true)}> Delete Paid Booking </IonButton>}
                    </IonCol>
                    }
            
                </IonRow>
                {authenticatedMerchent_context.accessRights[0] == 'admin' &&
                <IonRow>
                    <IonCol size='3'>
                        REFUND
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton_refund}} type='number' placeholder='Enter %' ref={enterRefundRef}></IonInput>
                        <h4 style={{display: displayResetButton_refund}}>{enterRefundRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_refund}} disabled={disableSetButton_refund} onClick={() => setRefundHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_refund}} disabled={disableResetButton_refund} onClick={() => resetRefundHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol size='3'>
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName,  detailData.momo_external_id, 'refund'])}> Refund </IonButton>}
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName,  detailData.momo_external_id, 'transfer'])}> Transfer </IonButton>}
                        {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => submitPay_refund([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, detailData.roomID, detailData.roomGuestFirstName, detailData.roomGuestLastName,  detailData.momo_external_id, 'deposit'])}> Deposit </IonButton>}                    
                    
                    </IonCol>
                </IonRow>
            }
            </IonGrid>
                    )
                }
            )}
            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>
            <EnterPasswordModal openModal={ showPasswordModal_refund } closeModal={() => setShowPasswordModal_refund(false)} onSubmitPassword={ onSubmitPasswordHandler_refund }></EnterPasswordModal>

            {checkInModal == true && <EnterCheckInInfoModal openModal={ checkInModal } closeModal={() => closeModalHandler_checkIn()} data={{
                        status: bookingStatus,
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice,
                        bookedFirstName: bookedFirstName, 
                        bookedLastName: bookedLastName,
                        bookedPhoneNumber: bookedPhoneNumber,
                        bookedEmail: bookedEmail,
                        bookedStartDate: bookedStartDate,
                        bookedEndDate: bookedEndDate,
                        bookingID: props.data.bookingID
                        }}></EnterCheckInInfoModal>}

            {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: roomGuestInvoiceAttachment, 
                                        roomID: roomID, 
                                        roomSalePrice: roomSalePrice,
                                        }}></ViewInvoiceModal>}

            {showUpdateBookedRoomModal == true && <UpdateRoomBookedModal openModal={ showUpdateBookedRoomModal } closeModal={() => setShowUpdateBookedRoomModal(false)} startDate={new Date(bookedStartDate).toISOString().substr(0, 10)} endDate={new Date(bookedEndDate).toISOString().substr(0, 10)} currentRoom={props.data.roomID} currentRoom_multiple={false} bookingID={props.data.bookingID}></UpdateRoomBookedModal>}

            {showUpdateCheckInDateModal == true && <UpdateCheckInDateModal openModal={ showUpdateCheckInDateModal } closeModal={() => setShowUpdateCheckInDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckInDateModal>}

            {showUpdateCheckOutDateModal == true && <UpdateCheckOutDateModal openModal={ showUpdateCheckOutDateModal } closeModal={() => setShowUpdateCheckOutDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckOutDateModal>}

            </IonContent>
            <IonFooter className='appFooter'>
                    <IonGrid>
                        <IonRow>
                            <IonCol size="12">
                                <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}